import { AddBroadcasts as AddBroadcastsComponent } from './AddBroadcasts.component';
import { connector } from './AddBroadcasts.connector';

export const AddBroadcasts = connector(AddBroadcastsComponent);
